import { stringNotEmpty } from '../../utilities';


const SEARCH_FILTER = 'SEARCH_FILTER';
const ATTRIBUTE_FILTER = 'ATTRIBUTE_FILTER';

/**
 * Bevat zoek- en attrubuutfilter objecten
 */
class FilterObject {

    /**
     * Initialization
     * @param {*} value FilterObject value
     * @param {*} filterAttribute FilterObject filterAttribute
     * @param {*} operator FilterObject operator
     * @param {*} visible FilterObject visible
     * @param {*} caseSensitive FilterObject caseSensitive
     * @param {*} dataType FilterObject dataType
     */
    constructor({ filterAttribute, operator, value, visible, type, caseSensitive, dataType, omitCase }) {
        this.filterAttribute = filterAttribute;
        this.operator = operator;
        this.value = value;
        this.visible = visible;
        this.type = type;
        this.caseSensitive = caseSensitive;
        this.dataType = dataType;
        this.omitCase = omitCase || false;
    }

    /**
     * Statische method om een zoekfilter object te maken
     * @param {[type]} options.filterAttribute [description]
     * @param {[type]} options.operator        [description]
     * @param {[type]} options.value           [description]
     * @param {[type]} options.visible         [description]
     * @return {FilterObject} FilterObject object
     */
    static SearchFilterObject({ filterAttribute, operator, value, visible }) {
        return new FilterObject({
            filterAttribute: filterAttribute,
            operator: operator,
            value: value,
            visible: visible,
            type: SEARCH_FILTER,
            caseSensitive: false
        });
    }

    /**
     * Statische method om een zoekfilter object te maken
     * @param {[type]} options.filterAttribute [description]
     * @param {[type]} options.operator        [description]
     * @param {[type]} options.value           [description]
     * @param {[type]} options.visible         [description]
     * @param {[type]} options.caseSensitive   [description]
     * @param {[type]} options.dataType        [description]
     * @return {FilterObject} FilterObject object
     */
    static AttributeFilterObject({ filterAttribute, operator, value, visible, caseSensitive, dataType, omitCase }) {
        return new FilterObject({
            filterAttribute: filterAttribute,
            operator: operator,
            value: value,
            visible: visible,
            type: ATTRIBUTE_FILTER,
            caseSensitive: caseSensitive,
            dataType: dataType,
            omitCase
        });
    }

    /**
     * Static method to create a personal filter object
     * @param {[type]} creator [user name filter value]
     * @return {FilterObject} FilterObject object
     */
    static personalFilterObject(creator) {
        return new FilterObject({
            filterAttribute: 'aanmaker',
            operator: '=',
            value: creator,
            visible: false,
            // treat personal filer as a search filter
            type: ATTRIBUTE_FILTER,
            caseSensitive: false
        });
    }

    $_calculateFormat_DMY(reEntrance) {
        const dateObject = {
            day: 0,
            month: 0,
            year: 0
        };
        const tokens = this.value.split('-');

        if (tokens.length === 3) {
            if (tokens[0].length === 4) {
                // foutief formaat opgegeven
                reEntrance++;
                this.setDateValue({ fromFormat: 'YYYY-MM-DD' }, reEntrance);
                // null in case of wrong format
                return null;
            }
            dateObject.day = tokens[0] * 1;
            dateObject.month = tokens[1] * 1;
            dateObject.year = tokens[2] * 1;
        }
        return dateObject;
    }

    $_calculateFormat_YMD(reEntrance) {
        const dateObject = {
            day: 0,
            month: 0,
            year: 0
        };
        const tokens = this.value.split('-');

        if (tokens.length === 3) {
            if (tokens[0].length === 2) {
                // foutief formaat opgegeven
                reEntrance++;
                this.setDateValue({ fromFormat: 'DD-MM-YYYY' }, reEntrance);
                // null in case of wrong format
                return null;
            }
            dateObject.year = tokens[0] * 1;
            dateObject.month = tokens[1] * 1;
            dateObject.day = tokens[2] * 1;
        }
        return dateObject;
    }

    /**
     * Zet de (datum) value om naar het juiste formaat: "YYYY-mm-dd HH:MM:SS"
     * Hier wordt geen validatie gedaan, enkel omzetten naar een ander formaat.
     * @param {string} options.fromFormat datum formaat van de invoer
     * @param {number} reEntrance - teller voor aantal recursies
     */
    setDateValue({ fromFormat }, reEntrance = 0) {
        let calculatedDate = null;
        // enkel voor een datum veld uitvoeren
        if (this.dataType && this.dataType.indexOf('date') > -1) {
            // recursie beperken
            if (reEntrance > 2) {
                return;
            }

            // verwijder tijdstip uit datum indien aanwezig
            if (this.value.split(' ').length > 1) {
                this.value = this.value.split(' ')[0];
            }

            // formaat in hoofdletters
            const fromFormatUC = fromFormat.toUpperCase();
            // Formaat 1:
            if (fromFormatUC === 'DD-MM-YYYY') {
                calculatedDate = this.$_calculateFormat_DMY(reEntrance);
            }
            // Formaat 2:
            if (fromFormatUC === 'YYYY-MM-DD') {
                calculatedDate = this.$_calculateFormat_YMD(reEntrance);
            }
            // converteer naar CQL datum formaat
            if (calculatedDate && this.operator === '<=') {
                // tot en met middernacht
                this.value = `${calculatedDate.year}-${calculatedDate.month}-${calculatedDate.day} 23:59:59`;
            } else if (calculatedDate) {
                // vanaf middernacht
                this.value = `${calculatedDate.year}-${calculatedDate.month}-${calculatedDate.day} 00:00:00`;
            }
        }
    }
}





function expandFilterValue(value) {
    if (!stringNotEmpty(value) || !value.toUpperCase().includes('<SYSDATE')) {
        // return original value
        return value;
    }

    // remove the pre- en posttoken < and >
    let valueTokens = value.split('<');
    if (valueTokens.length <= 1) {
        // return original value
        return value;
    }

    let daysFromNow = 0;
    // the part before <SYSDATE>
    const preToken = valueTokens[0];
    valueTokens = valueTokens[1].split('>');
    // the part after <SYSDATE>
    const postToken = valueTokens[1];
    valueTokens = valueTokens[0].toUpperCase().split('SYSDATE-');
    if (valueTokens.length > 1) {
        daysFromNow = Number(valueTokens[1]) * -1;
    } else {
        valueTokens = valueTokens[0].toUpperCase().split('SYSDATE+');
        if (valueTokens.length > 1) {
            daysFromNow = Number(valueTokens[1]) * 1;
        }
    }
    // calcalute date
    const dateToken = calculateDate(daysFromNow);
    // stel de uivoer samen
    return `${preToken}${dateToken}${postToken}`;
}

export function calculateDate(daysFromNow) {
    const date = new Date();
    date.setDate(date.getDate() + daysFromNow);
    // return string format
    let dayToken;
    const day = date.getDate();
    let monthToken;
    const month = date.getMonth() + 1;
    // format day
    if (day < 10) {
        dayToken = `0${day}`;
    } else {
        dayToken = `${day}`;
    }
    if (month < 10) {
        monthToken = `0${month}`;
    } else {
        monthToken = `${month}`;
    }
    return `${dayToken}-${monthToken}-${date.getFullYear()}`;
}

export {
    FilterObject,
    expandFilterValue,
    // constanten
    SEARCH_FILTER,
    ATTRIBUTE_FILTER
};
